import classnames from "classnames";
import React from "react";
import { Message } from "@JohnLewisPartnership/jl-design-system/dist/components/message/Message";
import { LiveChatOutlined } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/LiveChatOutlined";
import OpeningHours from "../opening-hours/OpeningHours";

import styles from "./contact-live-chat-unavailable.module.scss";

function ContactLiveChatUnavailable({ className, config: { displayTimes }, showGreyBackground = true }) {
  return (
    <div
      className={classnames(
        className,
        styles["contact-live-chat-unavailable"],
        showGreyBackground && styles["contact-live-chat-unavailable-grey-bg"],
      )}
    >
      <h4>Live chat unavailable</h4>
      <Message
        body="Sorry, our agents aren’t available right now – we’re either outside our hours or helping other customers. Please try again later or contact us another way."
        type="warning"
      />
      <button
        type="button"
        className={classnames(styles["live-chat-button"])}
        data-testid="live-chat-unavailable-button"
      >
        <div />
        <span className={styles.chatIcon}>
          <LiveChatOutlined />
          Start chat
        </span>
      </button>
      <OpeningHours openingHours={displayTimes} />
    </div>
  );
}

export default ContactLiveChatUnavailable;
